import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_clarity-to-glow/artifacts/yyf2ppco_AGPT%20Logo%20%2823%29.png";

export const Logo = ({ dark = false }) => {
  return (
    <a
      href="https://beambitious.chat"
      className="inline-flex items-center select-none transition-opacity duration-300 hover:opacity-80"
      data-testid="agpt-logo"
      aria-label="a.gpt — beambitious.chat"
    >
      <img
        src={LOGO_URL}
        alt="a.gpt"
        className="h-12 w-12 sm:h-14 sm:w-14 object-contain"
        style={{ borderRadius: "4px" }}
        loading="eager"
        decoding="async"
      />
    </a>
  );
};
